import { Link, useLocation } from 'react-router-dom';

function ContactUsLink({ childEl }) {
  const location = useLocation();

  // Check if the current path is already "/contact"
  const isOnContactUsPage = location.pathname === '/contact';

  return isOnContactUsPage ? childEl : <Link to="/contact">{childEl}</Link>;
}

export default ContactUsLink;
